/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { Card, CardBody, Flex } from "@chakra-ui/react";
import { FaEdit } from "react-icons/fa";
import Loader from "components/PageLoader";
import StockFilterBarV2 from "components/stock/filter-bar";
import { useUser } from "../../hooks/use-user";
import { Paths } from "../../routes/paths";
import { HasPermission } from "../../utils/helper";
import { useGetStockListPaginated } from "../../services/stock";
import { initialDataState } from "./constants";

export default function StockList() {
  const [stock, setStock] = useState([]);

  const user = useUser();
  const [dataState, setDataState] = useState(initialDataState);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 25;
  const [filters, setFilters] = useState({
    searchCriteria: "",
    selectedCashCenterId: user.CashCenterId,
    selectedCustomerId: "",
  });
  const {
    mutate: getStocksList,
    isSuccess: stockListAvailable,
    data: stocksList,
    isPending: gettingStocksList,
    error: stockListError,
    reset: resetStockList,
  } = useGetStockListPaginated();

  useEffect(() => {
    if (stockListAvailable) {
      setStock(stocksList.data.data);
      setTotalRecords(stocksList.data.totalRecords);
      resetStockList();
    }
  }, [stockListAvailable, stockListError]);

  useEffect(() => {
    setCurrentPage(1);
    getStocksList({
      pageNumber: 1,
      pageRowCount: pageSize,
      searchCriteria: filters.searchCriteria,
      operationDate: new Date(),
      cashCenterId: filters.selectedCashCenterId || "",
      customerId: filters.selectedCustomerId || "",
    });
  }, [filters]);

  const viewStockCell = ({ dataItem }) => {
    return (
      <td>
        {canViewDetails ? (
          <Flex
            as={Link}
            to={`${Paths.stockDetails}/${dataItem.stockId}`}
            style={{ cursor: "pointer", color: "blue" }}
            w="100%"
            title="View Details"
          >
            {dataItem.topSerialNo}
          </Flex>
        ) : (
          <>{dataItem.topSerialNo}</>
        )}
      </td>
    );
  };

  const editStockCell = ({ dataItem }) => {
    return (
      <td>
        <Flex
          as={Link}
          to={`${Paths.editStock}/${dataItem.stockId}`}
          justifyContent="center"
          style={{ cursor: "pointer" }}
          w="100%"
          title="Edit User"
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  const onPageChange = (e) => {
    const _page = e.page.skip / pageSize + 1;
    setCurrentPage(_page);
    getStocksList({
      pageNumber: _page,
      pageRowCount: pageSize,
      searchCriteria: filters.searchCriteria,
      operationDate: new Date(),
      cashCenterId: filters.selectedCashCenterId || "",
      customerId: filters.customerId || "",
    });
  };

  const canEdit = useMemo(() => {
    return HasPermission(user, "Stock", "Edit");
  }, [user]);
  const canViewDetails = useMemo(() => {
    return HasPermission(user, "Stock", "View");
  }, [user]);

  return (
    <Flex className="main-container">
      {gettingStocksList ? <Loader /> : <></>}
      <Card m="20px">
        <CardBody>
          <StockFilterBarV2
            getList={(filter, cashCenterId, customerId) => {
              setFilters({
                searchCriteria: filter,
                selectedCashCenterId: cashCenterId,
                selectedCustomerId: customerId,
              });
            }}
          />
          <Grid
            data={process(stock || [], dataState)}
            {...dataState}
            onDataStateChange={(e) => {
              setDataState(e.dataState);
            }}
            filterable
            sortable
            pageable
            total={totalRecords}
            pageSize={pageSize}
            skip={(currentPage - 1) * pageSize}
            onPageChange={onPageChange}
            className="stock-grid"
          >
            <Column
              field="topSerialNo"
              title="Top Serial No"
              cell={viewStockCell}
              width={180}
            />
            <Column field="description" title="Description" />
            <Column field="customer" title="Customer" width={240} />
            <Column field="denomination" title="Denomination" width={140} />
            <Column field="cassetteType" title="Cassette Type" width={120} />
            <Column title="Limit" field="limit" width={120} />
            <Column title="Maker" field="maker" width={120} />
            <Column title="Status" field="status" width={120} />
            {canEdit ? (
              <Column
                field="status"
                title="Edit"
                headerClassName="text-center"
                className="text-center"
                width={80}
                cell={editStockCell}
              />
            ) : (
              <></>
            )}
            {/* {canDelete ? (
              <Column
                field="status"
                title="Delete"
                headerClassName="text-center"
                className="text-center"
                width={80}
                cell={deleteStockCell}
              />
            ) : (
              <></>
            )} */}
          </Grid>
        </CardBody>
      </Card>
    </Flex>
  );
}
